import { useQuery } from '@tanstack/react-query';

import { fetcher } from '@/utils/fetcher';
import { TemplateResponse, TemplateResponseSchema } from '@/types/Template';
import { RETAIL_API_URL } from 'src/utils/envConfig';

export const useTemplates = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['read-templates'],
    queryFn: async () => {
      const result = await fetcher<TemplateResponse>(
        `${RETAIL_API_URL}/templates/read`,
      );

      const parsedResult = TemplateResponseSchema.safeParse(result);

      if (!parsedResult.success) {
        console.error(
          "Something didn't work reading the templates: ",
          parsedResult.error.errors[0].message,
        );

        throw new Error(parsedResult.error.errors[0].message);
      }

      return parsedResult.data;
    },
  });

  return { data, isLoading };
};
